@let currentUser = this.currentUser$ | async;
<cam-loader [isLoading]="this.requestState.isLoading()">
  <cam-error [message]="this.requestState.getErrorMessage()" [code]="this.requestState.getErrorStatus()">
    <cam-empty [isEmpty]="!currentUser">
      @if (currentUser) {
        @if (this.editMode()) {
          <cam-loader class="actions" [isLoading]="this.editRequestState.isLoading()">
            <cam-button (action)="this.cancelEdit()" type="secondary">
              {{ 'user.my-profile.cta.cancel' | translate }}
            </cam-button>
            <cam-button (action)="this.toggleEdit(currentUser)">
              {{ 'user.my-profile.cta.save' | translate }}
            </cam-button>
          </cam-loader>
          <cam-error
            [message]="this.editRequestState.getErrorMessage()"
            [code]="this.editRequestState.getErrorStatus()"
          >
            @if (this.form()) {
              <cam-form
                [inputs]="this.form() ?? []"
                (valid)="this.validation($event, currentUser)"
                [askValidation$]="this.askValidation$"
                [canDisplayButton]="false"
              ></cam-form>
            }
          </cam-error>
        } @else {
          <div class="flex-column g-space-sm">
            <cam-card [fullHeight]="true">
              <cam-card-header>
                <cam-card-title>
                  <div class="space-between">
                    <cam-title [level]="4" [isBold]="true">
                      {{ 'user.my-profile.info.title' | translate }}
                    </cam-title>
                    @if (this.canModify()) {
                      <cam-font-icon name="modify" type="sm" (click)="this.toggleEdit(currentUser)"></cam-font-icon>
                    }
                  </div>
                </cam-card-title>
              </cam-card-header>

              <cam-card-content>
                <div class="info-container">
                  <div class="logo-container align-center">
                    <cam-user-logo
                      [user]="this.getUserLogo(currentUser)"
                      [size]="'xl'"
                      [forcedSize]="100"
                    ></cam-user-logo>
                  </div>
                  <div class="info-grid">
                    <cam-item-display [label]="'user.my-profile.lastName'">
                      @if (currentUser.lastName) {
                        {{ currentUser.lastName }}
                      } @else {
                        -
                      }
                    </cam-item-display>
                    <cam-item-display [label]="'user.my-profile.firstName'">
                      @if (currentUser.firstName) {
                        {{ currentUser.firstName }}
                      } @else {
                        -
                      }
                    </cam-item-display>
                    <cam-item-display [label]="'user.user-profile.email'">
                      @if (currentUser.userName) {
                        <cam-link (action)="this.mailTo(currentUser.userName)">{{ currentUser.userName }}</cam-link>
                      } @else {
                        -
                      }
                    </cam-item-display>
                    <cam-item-display [label]="'user.user-profile.phone'">
                      @if (currentUser.phoneNumber) {
                        {{ currentUser.phoneNumber }}
                      } @else {
                        -
                      }
                    </cam-item-display>
                    <cam-item-display [label]="'user.my-profile.culture'">
                      @if (currentUser.culture) {
                        <cam-culture [cultures]="[currentUser.culture]"></cam-culture>
                      } @else {
                        -
                      }
                    </cam-item-display>
                    <cam-item-display [label]="'user.my-profile.trigram'">
                      @if (currentUser.trigram) {
                        {{ currentUser.trigram }}
                      } @else {
                        -
                      }
                    </cam-item-display>
                    @if (this.canDisplayFunctions()) {
                      <cam-item-display [label]="'user.my-profile.functions'">
                        @if (currentUser.functions && currentUser.functions.length > 0) {
                          <div class="flex-start g-space-xs">
                            @for (userFunction of currentUser.functions; track userFunction.id) {
                              <cam-badge [value]="userFunction.name"></cam-badge>
                            }
                          </div>
                        } @else {
                          -
                        }
                      </cam-item-display>
                    }
                  </div>
                </div>
              </cam-card-content>
            </cam-card>

            @if (this.canDisplayClient() && currentUser.tenantInformations.length > 0) {
              <cam-card>
                <cam-card-header>
                  <cam-card-title>
                    <cam-title [level]="4" [isBold]="true">
                      {{ 'user.my-profile.client.title' | translate }}
                    </cam-title>
                  </cam-card-title>
                </cam-card-header>

                <cam-card-content>
                  @if (currentUser.tenantInformations.length === 1) {
                    <cam-item-display [label]="'user.clientnumber'">
                      @if (currentUser.tenantInformations[0].tenantPersonId) {
                        {{ currentUser.tenantInformations[0].tenantPersonId }}
                      } @else {
                        -
                      }
                    </cam-item-display>
                  } @else {
                    <cam-list-container>
                      @for (tenantInformation of currentUser.tenantInformations; track tenantInformation.id) {
                        <cam-list-element [withSeparator]="false">
                          <cam-list-title>{{ tenantInformation.tenantName }}</cam-list-title>
                          <cam-list-extra-information>
                            @if (tenantInformation.tenantPersonId) {
                              {{ tenantInformation.tenantPersonId }}
                            }
                          </cam-list-extra-information>
                        </cam-list-element>
                      }
                    </cam-list-container>
                  }
                </cam-card-content>
              </cam-card>
            }
          </div>
        }
      }
    </cam-empty>
  </cam-error>
</cam-loader>
